$ ->

  $('.animals').on 'click', '.animal', (event) ->
    event.preventDefault()

    $('.animal').removeClass('active')
    $(this).addClass('active')
